import { ProductionUnit, Unit, ValidationRangeTypes } from '~/constants';
import {
  nonEmptyString,
  range,
  validFloat,
  validationChain,
  areRecStateFieldsEnabled,
  isIllinoisShinesProgram,
  isNewJerseyQuote,
  unitRange,
  avoidedCostOfSolar
} from '../validators';
import { additionalLineItemSchema } from '../util';
import { Project } from '~/types/project';
import { sizeKwdc } from '~/utils/calculators';

const validation = {
  addressState: nonEmptyString,
  pricingType: nonEmptyString,
  projectArrays: [{
    type: nonEmptyString,
    sizeKwdc: validationChain(validFloat, range(0, 40000, ValidationRangeTypes.NUMBER)),
    sizeKwac: validationChain(isIllinoisShinesProgram(validFloat), range(0, 40000, ValidationRangeTypes.NUMBER)),
    yearOneProduction: (value: number, project: Project, index: number) => {
      const totalSizeKwdc = sizeKwdc(project?.projectArrays);
      const unit = project?.projectArrays?.[index]?.yearOneProductionUnit;
      if (unit === ProductionUnit.KWHKW) {
        return range(500, 3000, ValidationRangeTypes.NUMBER)(value);
      } else {
        let min = 500 * totalSizeKwdc;
        let max = 3000 * totalSizeKwdc;
        if (value < min || value > max) {
          return 'Outside expected range - please confirm unit selection.';
        }
      }
    },
  }],
  epcCost: (value: number, project: Project) => {
    //const isValidFloat = validFloat(value);
    const totalSizeKwdc = sizeKwdc(project?.projectArrays);
    const unit = project?.epcCostUnit;
    if (unit === Unit.WDC) {
      return range(1, 10, ValidationRangeTypes.DOLLARS)(value);
    } else if (unit === Unit.TOTAL) {
      let min = 1 * totalSizeKwdc * 1000;
      let max = 5 * totalSizeKwdc * 1000;
      if (value < min || value > max) {
        return 'Outside expected range - please confirm unit selection.';
      }
    }
    return false;
  },
  contractTerm: validationChain(validFloat, range(5, 40, ValidationRangeTypes.NUMBER)),
  epcCompanyName: nonEmptyString,
  contractRate: validFloat,
  contractEscalator: validationChain(validFloat, range(0, 10, ValidationRangeTypes.PERCENT)),
  upfrontIncentives: (value: number, project: Project) => {
    const totalSizeKwdc = sizeKwdc(project?.projectArrays);
    const unit = project?.upfrontIncentiveUnit;
    if (unit === Unit.WDC) {
      return unitRange(0, 10, unit!)(value);
    } else {
      let min = 0;
      let max = 10 * totalSizeKwdc * 1000;
      if (value < min || value > max) {
        return 'Outside expected range - please confirm unit selection.';
      }
    }
  },
  yearOneSavings: validFloat,
  avoidedCostOfSolar: validationChain(validFloat, avoidedCostOfSolar(0.01, 0.50)),
  propertyTaxType: nonEmptyString,
  propertyTaxAmount: validFloat,
  propertyTaxEscalator: validFloat,
  additionalRevenues: [additionalLineItemSchema],
  additionalOperatingExpenses: [additionalLineItemSchema],
  recOwnership: isNewJerseyQuote(nonEmptyString),
  recsData: {
    'Illinois': {
      isShinesProgram: areRecStateFieldsEnabled('Illinois', nonEmptyString),
      recAllocation: isIllinoisShinesProgram(nonEmptyString),
      recProjectCategory: isIllinoisShinesProgram(nonEmptyString),
      recUtilityGroup: isIllinoisShinesProgram(nonEmptyString),
      recProgramYear: isIllinoisShinesProgram(nonEmptyString)
    },
    'New Jersey': {
      recAllocation: areRecStateFieldsEnabled('New Jersey', nonEmptyString),
      recValue: areRecStateFieldsEnabled('New Jersey', validationChain(validFloat, range(1, 500, ValidationRangeTypes.NUMBER))),
      recContractTerm: areRecStateFieldsEnabled('New Jersey', validFloat)
    }
  },
};

export default validation;